var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEmailCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.1,186.6c1.1-2.9,0.6-6.1-1.2-8.5c-2.7-3.6-4.9-6.5-63.4-9.3c-33-1.6-76.4-2.1-122.2-3         c-84.4-0.6-183.1,1.2-208.4,8.4l-5.4,1.6l-0.5,5.4c-2.8,21-26.4,206.2,1.5,238.7c13.5,15.4,80.5,23.5,194.3,22.3         c60.8,0.5,121.5-3.5,181.7-12.1c1.7-0.3,3.3-0.7,4.9-1.4c13.9-8.3,16.6-52.6,17.1-174c0-28.9,0.3-61.7,1.6-67l0.5-0.9L507.1,186.6z         M484.9,188.6c-30.6,36.6-142.7,136.8-163,142.7c-8.7,2.5-20.9-9.7-33.9-22.9c-13.6-15.2-29.7-28-47.7-37.8         c-38.6-23.8-74.7-51.6-107.6-82.8C250,180.9,367.7,181.1,484.9,188.6z M120.8,199.9c32.2,30,66.9,57.3,103.7,81.5         C192,324.3,156,364.4,116.9,401.5C105.8,369.5,112.6,268.6,120.8,199.9z M128.9,413.4c40.4-38,77.4-79.4,110.5-123.8         c13.6,8.7,26,19.1,36.9,30.9c17,17.5,32.3,32.6,50.6,27.3l1-0.3c17.7-9.4,34.1-21,49-34.5c27.5,36.1,56.9,70.6,88.1,103.5         c-54.9,5.9-110.1,8.8-165.3,8.8C196,425.9,147.2,419.4,128.9,413.4z M481.1,408.3c-32.6-33.5-63.1-69.1-91.2-106.4         c35.1-29.9,75.3-67.6,98.6-92.3c-0.2,10.9-0.4,25.5-0.5,45.1c1.4,51.4-0.8,102.8-6.8,153.8L481.1,408.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEmailCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-email-circle.ea568058.svg";
export { ForwardRef as ReactComponent };